// Brand assets — uploaded by user, used directly per design guidelines.
// Note: URL filenames are misleading; mapping is set by actual image content.
export const ASSETS = {
  // Official Becoming H.E.R. gold-crown logo (black bg, gold H.E.R. w/ crown)
  logoMonogram:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_prophetess-toyee/artifacts/gpqetcwg_928C4EAC-179A-4647-B0C2-647CA0D4F6FE.jpeg",
  // Legacy BH brand-mock (kept for reference, no longer used in layout)
  logoMockup:
    "https://customer-assets.emergentagent.com/job_63882885-58da-4b30-92be-e95d0fb4acbb/artifacts/hp46iupq_IMG_0533.jpeg",
  // Founder professional headshot
  founderHeadshot:
    "https://customer-assets.emergentagent.com/job_63882885-58da-4b30-92be-e95d0fb4acbb/artifacts/0vem8x94_IMG_1411.jpeg",
  // "Mother May I" book cover flat-lay (kept for reference)
  bookCover:
    "https://customer-assets.emergentagent.com/job_63882885-58da-4b30-92be-e95d0fb4acbb/artifacts/kx94wgq0_mock-00668.png",
  // Yellow lilies & roses floral texture (re-uploaded)
  floralTexture:
    "https://customer-assets.emergentagent.com/job_prophetess-toyee/artifacts/ove15ao4_IMG_4886.jpeg",
};
